import React from "react";
import SupervisorHero from "../components/supervisorcomponents/SupervisorHero";

const SupervisorPage = () => {
  return (
    <div>
      <SupervisorHero />
    </div>
  );
};

export default SupervisorPage;
